import './App.css';

const getLogInURL = process.env.REACT_APP_LOGIN_URL;

function LogIn() {
  window.location.assign(getLogInURL);
}

export default LogIn;